import { render, staticRenderFns } from "./confirmotpedit.vue?vue&type=template&id=1f29fcd0&scoped=true"
import script from "./confirmotpedit.vue?vue&type=script&lang=js"
export * from "./confirmotpedit.vue?vue&type=script&lang=js"
import style0 from "./confirmotpedit.vue?vue&type=style&index=0&id=1f29fcd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f29fcd0",
  null
  
)

export default component.exports